import { Link, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'
import { useToast } from './Toast'
import Logo from './Logo'

export default function Navbar() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const toast = useToast()

  const handleSignOut = async () => {
    await supabase.auth.signOut()
    navigate('/login')
    toast('Signed out successfully')
  }

  return (
    <nav style={{
      background: 'var(--white)',
      borderBottom: '1.5px solid var(--surface-2)',
      position: 'sticky', top: 0, zIndex: 100,
    }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 60 }}>
        <Link to="/dashboard" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
          <Logo variant="icon" size={32} />
          <span style={{ fontFamily: 'var(--font-display)', fontSize: '1.15rem', color: 'var(--ink)' }}>
            Receipt Chaser
          </span>
        </Link>

        {user && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <span style={{ fontSize: '0.82rem', color: 'var(--ink-muted)', display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={{ width: 8, height: 8, background: 'var(--green)', borderRadius: '50%', display: 'inline-block' }}></span>
              {user.email}
            </span>
            <Link to="/dashboard" className="btn btn-ghost btn-sm" style={{ textDecoration: 'none' }}>Dashboard</Link>
            <Link to="/support" className="btn btn-ghost btn-sm" style={{ textDecoration: 'none' }}>Support</Link>
            <Link to="/settings" className="btn btn-ghost btn-sm" style={{ textDecoration: 'none' }}>⚙ Settings</Link>
            <button className="btn btn-ghost btn-sm" onClick={handleSignOut}>Sign out</button>
          </div>
        )}
      </div>
    </nav>
  )
}
